import React from "react";
import { Avatar } from "@mui/material";
import { getDeviceIcon } from "../../config/deviceIcons";

const GATEWAY_TYPE_ID = 2;

type DeviceAvatarProps = {
  deviceTypeId: number;
  iconId: number;
  size?: number;
};

const DeviceAvatar: React.FC<DeviceAvatarProps> = ({ deviceTypeId, iconId, size = 36 }) => {
  const IconComponent = getDeviceIcon(iconId);
  const isGateway = deviceTypeId === GATEWAY_TYPE_ID;

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: isGateway ? "var(--color-save)" : "var(--color-primary)",
      }}
    >
      <IconComponent sx={{ fontSize: size * 0.55, color: "white" }} />
    </Avatar>
  );
};

export default DeviceAvatar;
